import { ReactNode } from 'react';

export enum LanguageOptions {
  English = 'en-US',
  French = 'fr-CA'
}

export enum UnitsOptions {
  Imperial = 'imperial',
  Metric = 'metric'
}

export type SettingButtonData = {
  buttonText: string;
  buttonValue: string;
};

export type HelpMenuButtonData = {
  text: string;
  link: string;
};

export type AdditionalAppBarSettingsContent = {
  additionalUserProfileContent?: ReactNode;
  additionalHelpMenuContent?: HelpMenuButtonData[];
  listOfPermissions?: PermissionsDisplayData[];
  permissionOrder?: string[];
  showNetworkStatus?: boolean;
  appName?: AppName;
};

export interface PermissionsSet {
  permission?: string;
  featureFlag?: string;

  breweryPermissionSummary?: string;
  permissionAtOwnBrewery?: string;
  permissionAtAllBreweries?: string;
}

export interface EnhancedPermissionsSet extends PermissionsSet {
  hasPermission?: boolean;
  hasPermissionAtOwnBrewery?: boolean;
  hasPermissionAtAllBreweries?: boolean;
}

export interface PermissionsDisplayData {
  groupKey: string;
  permissions: PermissionsSet[];
  featureFlag?: string;
}

export interface EnhancedPermissionsDisplayData {
  groupName: string;
  permissions: EnhancedPermissionsSet[];
}

export enum AppName {
  BrewingSpecials = 'BrewingSpecials',
  BrewingRecipes = 'BrewingRecipes',
  SparePartsCockpit = 'SparePartsCockpit',
  SupplyDataManagementPortal = 'SupplyDataManagementPortal',
  KpiTree = 'KpiTree',
  BlockedBeer = 'BlockedBeer'
}
